<template>
  <div style="height: 100%;overflow: auto;">
    <div class="mb-20">
      <el-input v-model="keyword.name" size="small" clearable placeholder="微信用户" class="w-200 mr-20"></el-input>
      <el-select size="small" class="mr-20" v-model="keyword.is_pay" clearable placeholder="支付状态">
        <el-option value="0" label="未支付">未支付</el-option>
        <el-option value="1" label="已支付">已支付</el-option>
      </el-select>
      <el-date-picker
          v-model="keyword.date"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期" class="mr-20" size="small">
      </el-date-picker>
      <el-button type="primary" size="small" @click="search">搜索</el-button>
    </div>

    <el-table :data="list" border stripe>
      <el-table-column label="ID" prop="id" width="80px"></el-table-column>
      <el-table-column label="微信用户" prop="user.nickname"></el-table-column>
      <el-table-column label="订单号" prop="order_no"></el-table-column>
      <el-table-column label="支付金额" prop="money"></el-table-column>
      <el-table-column label="容量" prop="size">
        <template v-slot="scope">
          {{scope.row.size}}M
        </template>
      </el-table-column>
      <el-table-column label="到期时间" prop="end_time"></el-table-column>
      <el-table-column label="创建时间" prop="addtime"></el-table-column>
      <el-table-column label="支付状态" prop="">
        <template v-slot="scope">
          <el-tag type="success" size="small" v-if="scope.row.is_pay==1">已支付</el-tag>
          <el-tag type="info" size="small" v-if="scope.row.is_pay==0">未支付</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="支付时间" prop="pay_time"></el-table-column>
      <el-table-column label="操作" width="120px">
        <template v-slot="scope">
          <!--          <el-button type="primary" @click="admin_edit(scope.row.id)" size="small" style="margin-right: 10px;">编辑</el-button>-->
          <!--          <el-popconfirm title="确认操作？" @confirm="renew(scope.row.id)">-->
          <!--            <el-button type="primary" size="small" slot="reference">续费</el-button>-->
          <!--          </el-popconfirm>-->
          <el-popconfirm title="确认删除？" @confirm="del(scope.row.id)">
            <el-button type="danger" size="small" slot="reference">删除</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <div style="height: 60px;"></div>
    <layer-page :total="total" :page-size="20"></layer-page>
  </div>

</template>

<script>
import LayerPage from "@/components/layer-page.vue";
export default {
name: "media_list",
  components: {LayerPage},
  data(){
    return{
      list:[],
      page:1,
      total:0,
      keyword:{name:''}
    }
  },
  mounted : async function(){
    try{
      await this.get_list();
    }catch (e){
      console.log(e);
      return false;
    }
  },
  methods:{
    get_list: async function (){
      this.$_showLoading();
      let res = await this.$_api.company('media_order_list', {page: this.page,keyword:this.keyword});
      this.$_hideLoading();
      this.list = res.list;
      this.total = res.total;
    },
    search:function (){
      this.page = 1;
      this.list = [];
      this.get_list();
    },
    del:async function (id){
      let that = this;
      that.$_showLoading();
      let res = await that.$_api.company('media_del', {id:id});
      that.$_hideLoading();
      if (res.errcode == 0) {
        that.$_showToast(res.errmsg);
        that.get_list();
      }
    },
    page_change : async function  (e){
      try{
        this.page = e;
        this.list = [];
        await this.get_list();
      }catch (e){
        console.log(e);
        return false;
      }
    },
  }
}
</script>

<style scoped>

</style>